export const biomedicalEngineeringConst = {
  path: "/single-programs/biomedical-engineering",
  title: "ИНЖЕНЕРНО-МЕДИЦИНСКИЙ ФАКУЛЬТЕТ – БИОМЕДИЦИНСКАЯ ИНЖЕНЕРИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Биомедицинская инженерия — технология на службе здоровья</h2>
      <p>
        Это уникальная междисциплинарная программа, объединяющая знания в области инженерии, медицины и информационных технологий. Студенты
        учатся создавать и совершенствовать медицинское оборудование, системы диагностики, мониторинга и реабилитации.
      </p>
      <p>Программа востребована в условиях цифровизации здравоохранения и развития медицинских технологий.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Основы анатомии и физиологии человека</li>
        <li>Медицинская электроника и сенсорные системы</li>
        <li>Диагностические и реабилитационные устройства</li>
        <li>Биоматериалы и нанотехнологии</li>
        <li>Обработка биомедицинских сигналов и изображений</li>
        <li>3D-моделирование и прототипирование</li>
        <li>Медицинская робототехника и автоматизация</li>
        <li>Нормативы и стандарты ЕС в медицинской инженерии</li>
      </ul>
      <p>Обучение сочетает лабораторную практику, проектную деятельность и стажировки в медтех-компаниях и клиниках.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Инженер-медтехник</li>
        <li>Разработчик медицинского оборудования</li>
        <li>Специалист по эксплуатации и обслуживанию медтехники</li>
        <li>Инженер по биомедицинским проектам</li>
        <li>Консультант по внедрению технологий в здравоохранение</li>
        <li>Эксперт по техническому регулированию и стандартизации</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€50,000 до €95,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с высоким спросом</li>
        <li>Дистанционный или очный формат обучения</li>
        <li>Обучение на русском или английском языке</li>
        <li>Практика в инженерных и медицинских лабораториях</li>
        <li>Доступ к современным симуляторам и оборудованию </li>
        <li>Индивидуальное сопровождение от приёмной комиссии</li>
      </ul>
      <p>Будущее медицины — за инженерами</p>
      <p>
        Наши выпускники работают в клиниках, лабораториях, международных компаниях и научных центрах, разрабатывая технологии, которые
        спасают жизни.
      </p>
      <br />
      <p className="padding-left">
        «Биомедицинская инженерия — это вклад в здоровье будущих поколений. Мы учим создавать технологии, которые действительно помогают.»
      </p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам подобрать направление, оформить документы и успешно пройти весь процесс поступления.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Биомедицинская инженерия — технология на службе здоровья
    Это уникальная междисциплинарная программа, объединяющая знания в области инженерии, медицины и информационных технологий. Студенты учатся создавать и совершенствовать медицинское оборудование, системы диагностики, мониторинга и реабилитации.
    Программа востребована в условиях цифровизации здравоохранения и развития медицинских технологий.
    Что вы будете изучать?
    • Основы анатомии и физиологии человека
    • Медицинская электроника и сенсорные системы
    • Диагностические и реабилитационные устройства
    • Биоматериалы и нанотехнологии
    • Обработка биомедицинских сигналов и изображений
    • 3D-моделирование и прототипирование
    • Медицинская робототехника и автоматизация
    • Нормативы и стандарты ЕС в медицинской инженерии
    Обучение сочетает лабораторную практику, проектную деятельность и стажировки в медтех-компаниях и клиниках.
    Кем можно работать после окончания?
    • Инженер-медтехник
    • Разработчик медицинского оборудования
    • Специалист по эксплуатации и обслуживанию медтехники
    • Инженер по биомедицинским проектам
    • Консультант по внедрению технологий в здравоохранение
    • Эксперт по техническому регулированию и стандартизации
    Зарплата в Европе: от €50,000 до €95,000 в год
    Почему выбирают нас?
    • Европейский диплом с высоким спросом
    • Дистанционный или очный формат обучения
    • Обучение на русском или английском языке
    • Практика в инженерных и медицинских лабораториях
    • Доступ к современным симуляторам и оборудованию
    • Индивидуальное сопровождение от приёмной комиссии
    Будущее медицины — за инженерами
    Наши выпускники работают в клиниках, лабораториях, международных компаниях и научных центрах, разрабатывая технологии, которые спасают жизни.
    «Биомедицинская инженерия — это вклад в здоровье будущих поколений. Мы учим создавать технологии, которые действительно помогают.»

    Как поступить?
    Приёмная комиссия поможет вам подобрать направление, оформить документы и успешно пройти весь процесс поступления.
  `,
};
